export default __webpack_public_path__ + "img/pin_icons/circle_w.svg";